import { useEffect, useState } from "react"
import { Button, Space, Table, Select, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

type fetchParams = {
    store_id: any | undefined,
    entry_date: string | undefined,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        entry_date: undefined,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: true
    })

    const [data, setData] = useState<any>([])
    const [data2, setData2] = useState<any>([])

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        if (params.date) {
            params.entry_date = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        if (Array.isArray(params.store_id) && params.store_id.length > 0) {
            params.store_id = params.store_id.join(',')

        } else {
            params.store_id = null
        }

        axiosTable.get('/finance_center/business/results_list', {
            params: {
                ...params,
                date_type: 2
            }

        }).then((response: any) => {
            if (response) {
                setData(response.store_results_list)
                setData2([response.total_results])
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)

        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.entry_date = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        if (Array.isArray(params.store_id) && params.store_id.length > 0) {
            params.store_id = params.store_id.join(',')

        } else {
            params.store_id = null
        }

        baseAxiosComplete('/finance_center/business/results_excel', {
            params: {
                ...params,
                date_type: 2
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    return (<div className="common-page">
        {/* 财务中心 -> 经营管理 -> 每月经营数据 */}
        <BreadCrumb position={['财务中心', '每月经营数据']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores multiple={true} value={fetchOtherParams.store_id} onChange={(v: any) => { handleChange(v, 'store_id') }} />
                </div>
                <DatePicker style={{ marginRight: 8, marginBottom: 12 }} className="fl" placeholder={'选择日期'} picker="month" value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />

                <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>
            </Space>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} >
                <Column fixed title="日期" dataIndex="entry_date" key="entry_date" />
                <Column fixed title="门店" dataIndex="store_name" key="store_name" />
                <Column title="月子总实收" dataIndex="yuezi_total_paid_amount" key="yuezi_total_paid_amount" />
                <Column title="签单实收" dataIndex="yuezi_deal_paid_amount" key="yuezi_deal_paid_amount" />
                <Column title="尾款实收" dataIndex="yuezi_left_paid_amount" key="yuezi_left_paid_amount" />
                <Column title="诚意金实收" dataIndex="yuezi_earnest_money_paid_amount" key="yuezi_earnest_money_paid_amount" />
                <Column title="续住收款" dataIndex="yuezi_continue_paid_amount" key="yuezi_continue_paid_amount" />
                <Column title="其他收款" dataIndex="yuezi_other_pay_amount" key="yuezi_other_pay_amount" />
                <Column title="现金实收" dataIndex="yuezi_cash_paid_amount" key="yuezi_cash_paid_amount" />
                <Column title="合同总金额" dataIndex="yuezi_agreement_total_amount" key="yuezi_agreement_total_amount" />
                <Column title="总任务" dataIndex="general_task" key="general_task" />
                <Column title="完成比例" dataIndex="completion_rate" key="completion_rate" />
                <Column title="签单数" dataIndex="yuezi_deal_count" key="yuezi_deal_count" />
                <Column title="月子退款金额" dataIndex="yuezi_refund_amount" key="yuezi_refund_amount" />
                <Column title="产康总实收" dataIndex="chankang_total_paid_amount" key="chankang_total_paid_amount" />
                <Column title="产康现金实收" dataIndex="chankang_cash_paid_amount" key="chankang_cash_paid_amount" />
                <Column title="摄影胎发总实收" dataIndex="photo_total_paid_amount" key="photo_total_paid_amount" />
                <Column title="摄影胎发现金实收" dataIndex="photo_cash_paid_amount" key="photo_cash_paid_amount" />
                <Column title="产康退款金额" dataIndex="chankang_refund_amount" key="chankang_refund_amount" />
                <Column title="领佳合同总金额" dataIndex="lingjia_agreement_total_amount" key="lingjia_agreement_total_amount" />
                <Column title="领佳总实收" dataIndex="lingjia_total_paid_amount" key="lingjia_total_paid_amount" />
                <Column title="培训总实收" dataIndex="train_total_paid_amount" key="train_total_paid_amount" />
                <Column title="发证总实收" dataIndex="certificate_total_paid_amount" key="certificate_total_paid_amount" />
                <Column title="领佳现金实收" dataIndex="lingjia_cash_paid_amount" key="lingjia_cash_paid_amount" />
                <Column title="领佳退款金额" dataIndex="lingjia_refund_amount" key="lingjia_refund_amount" />
                <Column title="在住人数" dataIndex="check_in_num" key="check_in_num" />
                <Column title="当日新增入住" dataIndex="new_check_in" key="new_check_in" />
                <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
            </Table>
        </div>

        <div className="common-main">
            <h3>当月汇总</h3>

            <Table loading={loading} dataSource={data2} scroll={{ x: 'max-content' }} bordered={true} >
                <Column fixed title="日期" dataIndex="entry_date" key="entry_date" />
                <Column title="月子总实收" dataIndex="yuezi_total_paid_amount" key="yuezi_total_paid_amount" />
                <Column title="签单实收" dataIndex="yuezi_deal_paid_amount" key="yuezi_deal_paid_amount" />
                <Column title="尾款实收" dataIndex="yuezi_left_paid_amount" key="yuezi_left_paid_amount" />
                <Column title="诚意金实收" dataIndex="yuezi_earnest_money_paid_amount" key="yuezi_earnest_money_paid_amount" />
                <Column title="续住收款" dataIndex="yuezi_continue_paid_amount" key="yuezi_continue_paid_amount" />
                <Column title="其他收款" dataIndex="yuezi_other_pay_amount" key="yuezi_other_pay_amount" />
                <Column title="现金实收" dataIndex="yuezi_cash_paid_amount" key="yuezi_cash_paid_amount" />
                <Column title="合同总金额" dataIndex="yuezi_agreement_total_amount" key="yuezi_agreement_total_amount" />
                <Column title="总任务" dataIndex="general_task" key="general_task" />
                <Column title="完成比例" dataIndex="completion_rate" key="completion_rate" />
                <Column title="签单数" dataIndex="yuezi_deal_count" key="yuezi_deal_count" />
                <Column title="月子退款金额" dataIndex="yuezi_refund_amount" key="yuezi_refund_amount" />
                <Column title="产康总实收" dataIndex="chankang_total_paid_amount" key="chankang_total_paid_amount" />
                <Column title="产康现金实收" dataIndex="chankang_cash_paid_amount" key="chankang_cash_paid_amount" />
                <Column title="摄影胎发总实收" dataIndex="photo_total_paid_amount" key="photo_total_paid_amount" />
                <Column title="摄影胎发现金实收" dataIndex="photo_cash_paid_amount" key="photo_cash_paid_amount" />
                <Column title="产康退款金额" dataIndex="chankang_refund_amount" key="chankang_refund_amount" />
                <Column title="领佳合同总金额" dataIndex="lingjia_agreement_total_amount" key="lingjia_agreement_total_amount" />
                <Column title="领佳总实收" dataIndex="lingjia_total_paid_amount" key="lingjia_total_paid_amount" />
                <Column title="培训总实收" dataIndex="train_total_paid_amount" key="train_total_paid_amount" />
                <Column title="发证总实收" dataIndex="certificate_total_paid_amount" key="certificate_total_paid_amount" />
                <Column title="领佳现金实收" dataIndex="lingjia_cash_paid_amount" key="lingjia_cash_paid_amount" />
                <Column title="领佳退款金额" dataIndex="lingjia_refund_amount" key="lingjia_refund_amount" />
                <Column title="在住人数" dataIndex="check_in_num" key="check_in_num" />
                <Column title="当日新增入住" dataIndex="new_check_in" key="new_check_in" />
                <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
            </Table>
        </div>
    </div>)
}